module.exports = __webpack_public_path__ + "img/dataCont.899e4440.png";